import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactComponent as Undo } from '../../../assets/svg/Undo.svg'
import { getStaffStudentArchive } from '../../../server/server'
import ArchiveList from '../../archive/ArchiveList'

/**
 * "User activity" for one student: their archive as staff may see it (scoped to the
 * teacher's students, no anonymous content, journal answers withheld - see the API).
 */
const FeedbackHistoryView = ({ studentId, studentName, onClose }) => {
    const { t } = useTranslation()
    const fetchPage = useCallback((params) => getStaffStudentArchive({ ...params, student_id: studentId }), [studentId])

    return (
        <div className="feedback-student-modal">
            <div className="feedback-modal-header" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', background: '#5e639b' }}>
                <button type="button" className="history-back-button" onClick={onClose} aria-label={t('back')}>
                    <Undo style={{ color: '#BEBECE' }} />
                </button>
                <div className="history-header-title">
                    <p>{studentName}</p>
                    <p>{t('User activity')}</p>
                </div>
                <div className="history-back-button invisible" />
            </div>
            <div className="histrory-list-container archive-history">
                {!!studentId && <ArchiveList fetchPage={fetchPage} cacheKey={`staff:${studentId}`} viewer="staff" scrollId="scrollableDiv" className="archive--modal" />}
            </div>
        </div>
    )
}

export default FeedbackHistoryView
